module.exports = __webpack_public_path__ + "img/area_1.1ace7ad7.png";